import { render, staticRenderFns } from "./ComprehensiveReports.html?vue&type=template&id=c3b2c590&scoped=true&external"
import script from "./ComprehensiveReports.js?vue&type=script&lang=js&external"
export * from "./ComprehensiveReports.js?vue&type=script&lang=js&external"
import style0 from "./ComprehensiveReports.vue?vue&type=style&index=0&id=c3b2c590&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3b2c590",
  null
  
)

export default component.exports